export const NAME = 'authorize';
export const SIGN_IN_FORM = 'signInForm';
export const SIGN_UP_FORM = 'signUpForm';
export const FORGOT_PASSWORD_FORM = 'forgotPasswordForm';
export const RESET_PASSWORD_FORM = 'resetPasswordForm';
export const VERIFIER_CONFIRMATION_FORM = 'verifierConfirmationForm';
